import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c78c580&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78c580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c78c580')) {
      api.createRecord('5c78c580', component.options)
    } else {
      api.reload('5c78c580', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c78c580&scoped=true", function () {
      api.rerender('5c78c580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/main/src/page/manage/index.vue"
export default component.exports